import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { SITE_FOOTER_LEGAL_LINKS } from '../../util/siteSocials';

import BrandLockup from '../BrandLockup/BrandLockup';
import NamedLink from '../NamedLink/NamedLink';
import { SocialLinks } from '../../containers/FooterContainer/SiteFooter';

import css from './GuestMarketingFooter.module.css';

const LEGAL_NAMES = ['SafetyPage', 'TermsOfServicePage', 'PrivacyPolicyPage', 'SmsTermsPage', 'ContactPage'];

/**
 * Guest marketing footer for Login/FAQ-adjacent pages (Safety, Terms, Privacy).
 * Do not mount on Dashboard, How it works, or other SiteFooter pages.
 *
 * @returns {JSX.Element}
 */
const GuestMarketingFooter = () => {
  const legal = SITE_FOOTER_LEGAL_LINKS.filter(link => LEGAL_NAMES.includes(link.name));
  return (
    <footer className={css.footer} data-guest-footer="marketing">
      <div className={css.inner}>
        <NamedLink name="LandingPage" className={css.brand}>
          <BrandLockup size="compact" className={css.lockup} />
        </NamedLink>
        <p className={css.motto}>
          <FormattedMessage id="GuestMarketingFooter.motto" />
        </p>
        <div className={css.social}>
          <SocialLinks
            listClassName={css.socialList}
            linkClassName={css.socialLink}
            iconFill="#0b2b5b"
          />
        </div>
        <nav className={css.legal} aria-label="Legal">
          {legal.map((link, index) => (
            <span key={link.href}>
              {index > 0 ? (
                <span className={css.legalDot} aria-hidden="true">
                  |
                </span>
              ) : null}
              <NamedLink name={link.name} className={css.legalLink} to={link.to}>
                {link.label === 'Contact' ? (
                  <FormattedMessage id="GuestMarketingFooter.contact" />
                ) : (
                  link.label
                )}
              </NamedLink>
            </span>
          ))}
        </nav>
        <p className={css.copy}>
          <FormattedMessage id="GuestMarketingFooter.copyright" />
        </p>
      </div>
    </footer>
  );
};

export default GuestMarketingFooter;
